import { useEffect, useState } from "react"
import AddProjectModal from "@components/projects/add-project-modal"
import InviteUsersModal from "@components/users/invite-users"
import AddTaskModal from "@components/projects/add-task-modal"
import SwitchWorkSpace from "@pma/components/dashboard/switch-workspace"
import { useAuth } from "@stores/auth-store"
import Chat from "../ai/chat"

export const ModalProvider = () => {
  const [isMounted, setIsMounted] = useState(false)
  const { authConfig } = useAuth()

  const orgId = authConfig?.last_organization_id

  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {}, [orgId])

  if (!isMounted) {
    return null
  }

  return (
    <>
      <AddProjectModal />
      <InviteUsersModal />
      <AddTaskModal />
      <SwitchWorkSpace />
      <Chat />
    </>
  )
}
